import { Stack } from "@mui/material";

import { RootPaths } from "../App/paths";
import { ClipboardLogo } from "../lib/Content";
import { Button } from "../redesign/components/Button";
import { DEFAULT_SUPPORT_LINKS, SupportContext } from "../support/constants";
import { ContactSupportButton } from "../support/ContactSupportButton";
import { ErrorPageTemplate } from "./Template";

export function GenericErrorPage() {
  const handleRestart = () => {
    window.location.replace(RootPaths.APP_V2_HOME);
  };

  return (
    <ErrorPageTemplate
      illustration={<ClipboardLogo />}
      title="Oops! Something went wrong."
      description="We're sorry, but something went wrong. Please try again or contact support if the problem persists."
      actions={
        <Stack spacing={4} width="100%">
          <Button fullWidth variant="contained" size="large" onClick={handleRestart}>
            Restart App
          </Button>
          <ContactSupportButton
            supportContext={SupportContext.ERROR_FALLBACK_SCREEN}
            supportLink={DEFAULT_SUPPORT_LINKS.HOW_TO_CONTACT_SUPPORT}
          >
            Contact Support
          </ContactSupportButton>
        </Stack>
      }
    />
  );
}
